import React from 'react'
import styled from 'styled-components'
import { map } from 'lodash'

import { PageContainer } from '../../src/layout/containers/PageContainer'
import LinkCard from '../../src/components/LinkCard'
import { media } from '../../src/utils/style-utils'
import { LinkCardsSlice } from '../../prismicio-types'

const LinkCards = ({ slice }: { slice: LinkCardsSlice }) => {
	// return early if there are no items
	if (!slice.items || slice.items.length === 0) return <></>

	return (
		<Container>
			{map(slice.items, (item) => (
				<LinkCard item={item} />
			))}
		</Container>
	)
}

export default LinkCards

const Container = styled.section`
	${PageContainer}
	grid-column: 2 / -2;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: var(--spacer-sm);

	${media.phone`
		gap: var(--spacer-xs);
	`};
`
